import styled from 'styled-components';

export const SectionHeading = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--on-surface);
`;
